import React from 'react'
import { useRouter } from 'next/router'

const Custom404 = () => {
  const router = useRouter()

  const goHome = () => {
    router.push('/')
  }

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="max-w-lg mb-8">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <h2 className="text-3xl font-semibold text-gray-700 mt-4">Page Not Found</h2>
        <p className="text-lg text-gray-600 mt-4">
          Oops! The page you are looking for does not exist. It might have been moved or deleted.
        </p>
        <button
          onClick={goHome}
          className="mt-6 px-6 py-3 text-white bg-black hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-opacity-50 transition duration-300"
        >
          Go Home
        </button>
      </div>
      <div className="w-[150px] h-[150px] overflow-hidden">
        <svg
          width="100"
          height="100"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="object-cover w-full h-full"
        >
          <circle cx="11" cy="11" r="6" stroke="black" strokeWidth="1" />
          <line x1="16" y1="16" x2="22" y2="22" stroke="black" strokeWidth="1" strokeLinecap="round" />
          <line x1="8" y1="8" x2="14" y2="14" stroke="black" strokeWidth="1" strokeLinecap="round" />
          <line x1="8" y1="14" x2="14" y2="8" stroke="black" strokeWidth="1" strokeLinecap="round" />
        </svg>
      </div>
    </div>
  )
}

export default Custom404
